import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../theme';

const SecondaryTitle = styled.h3`
  border-bottom: 1px solid ${appTheme.system.active};
  color: ${appTheme.system.active};
  font-size: ${em(18)};
  line-height: 1.4;
  margin-top: ${em(23)};
  max-width: ${em(appTheme.sizing.formMaxWidth, 18)};
`;

export default SecondaryTitle;



// WEBPACK FOOTER //
// ./src/modules/common/SecondaryTitle.js